import { useEffect, useState } from 'react';

export interface RateSet {
  rooms: Record<string, number>;
  extraGuestFee: number;
}

// Dates are inclusive YYYY-MM-DD; the override applies to every night in range.
export interface RateOverride extends RateSet {
  id: string;
  startDate: string;
  endDate: string;
}

export interface Rates extends RateSet {
  overrides: RateOverride[];
  updatedAt: string | null;
}

export const DEFAULT_RATES: Rates = {
  rooms: { 'king-single': 75, 'full-double': 82 },
  extraGuestFee: 10,
  overrides: [],
  updatedAt: null,
};

export const RATES_URL = '/.netlify/functions/rates';

export const fetchRates = async (): Promise<Rates> => {
  const res = await fetch(RATES_URL, { cache: 'no-store' });
  if (!res.ok) throw new Error('Failed to load rates');
  return res.json();
};

// Falls back to the built-in defaults if the rates service is unreachable
// (e.g. plain `npm start` without Netlify Functions).
export const useRates = (): Rates => {
  const [rates, setRates] = useState<Rates>(DEFAULT_RATES);

  useEffect(() => {
    let cancelled = false;
    fetchRates()
      .then((r) => !cancelled && setRates(r))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return rates;
};
